import styled from 'styled-components'
import colors from '../../../tokens/colors'
import fonts from '../../../tokens/fonts'
import { defaultTheme } from '../../../theming/data/defaultTheme'
import { composeTheme } from '../../../utils/compose-theme'

export const Submenu = styled.ul.attrs((props) => composeTheme(props))`
  position: absolute;
  top: ${(props) => props.theme.navbar.submenuTop};
  right: ${(props) => props.theme.navbar.submenuRight};
  background: ${(props) => props.theme.navbar.submenuBackgoundColor};
  border: ${(props) => props.theme.navbar.submenuBorder};
  border-radius: ${(props) => props.theme.navbar.submenuBorderRadius};
  padding: ${(props) => props.theme.navbar.submenuPadding};
  list-style: none;
  box-shadow: ${(props) => props.theme.navbar.submenuBoxShadow};
  width: max-content;
  z-index: inherit;
`

export const Subitem = styled.li.attrs((props) => composeTheme(props))`
  &:not(:last-child) {
    margin-bottom: ${(props) => props.theme.navbar.subitemMarginBottom};
  }
`

export const Text = styled.span.attrs((props) => composeTheme(props))`
  margin-left: ${(props) => props.theme.navbar.submenuTextMarginLeft};
`

export const ActionLink = styled.button.attrs((props) => composeTheme(props))`
  -moz-osx-font-smoothing: inherit;
  -webkit-appearance: none;
  -webkit-font-smoothing: inherit;
  align-items: center;
  background: transparent;
  border: none;
  color: ${(props) => props.theme.navbar.subitemColor};
  display: flex;
  font-family: ${fonts.inter};
  font-size: ${(props) => props.theme.navbar.subitemFontSize};
  font-style: normal;
  font-weight: ${(props) => props.theme.navbar.subitemFontWeight};
  letter-spacing: 0em;
  line-height: ${(props) => props.theme.navbar.subitemFontHeight};
  margin: 0;
  outline: 0;
  overflow: visible;
  padding: 0;
  text-align: right;
  text-decoration: none;
  width: auto;
  cursor: pointer;

  &:hover {
    color: ${(props) =>
      props.theme.navbar.subitemHoverColor !== colors.brandColorPrimaryPure
        ? props.theme.navbar.subitemHoverColor
        : props.theme.brandColors.primaryPure};
    transition: color 0.25s;
    background-color: transparent;
  }
`

ActionLink.defaultProps = defaultTheme
Subitem.defaultProps = defaultTheme
Submenu.defaultProps = defaultTheme
Text.defaultProps = defaultTheme
